import * as ActionTypes from '../../constants/actions';

export const initialState = {
    nodes: {},
    edges: {},
    groups: {},
    shops: []
};

export default function entities(state = initialState, action) {
    return state;
}


// WEBPACK FOOTER //
// ./reducers/entities/index.js